import { Injectable } from "@angular/core";
import { TabUtilsService } from "../tab-utils.service";
import { NavigationEnd, Router } from "@angular/router";
import { TabType } from "@core/static/tabs";
import { InvestorTab, Tab } from "@core/models/types";
import { Nullable } from "primeng/ts-helpers";
import { AuthService } from "@core/auth/auth.service";
import { BehaviorSubject, filter, Subject } from "rxjs";
import { MixpanelService } from "@core/services/mixpanel.service";
import { StatsService } from "@core/services/stats.service";
import { GlobalModalService } from "@core/services/global-modal.service";
import { DeviceDetectorService } from "ngx-device-detector";
import { ModalUtilsService } from "../modal-utils.service";

import { Location } from "@angular/common";
import { DataFilter } from "@core/components/dynamic-table/dynamic-table.component";

@Injectable({
  providedIn: "root",
})
export class RouterService {
  public url!: string;
  currentTabIndex!: Tab;
  currentChildIndex!: Nullable<number>;
  tabType!: TabType;
  tabTotal!: number;
  destroy$ = new Subject<void>();


  constructor(
    private tabUtilsService: TabUtilsService,
    public router: Router,
    private mixpanelService: MixpanelService,
    public authService: AuthService,
    public statsService: StatsService,
    private globalModalService: GlobalModalService,
    private deviceDetectorService: DeviceDetectorService,
    private modalUtilsService: ModalUtilsService,
    private location: Location,
  ) {
    this.subscribeToTabSwitch();
  }

  get tabs() {
    return this.tabUtilsService.tabs;
  }

  onAvailableUserTabs() {
    return this.tabUtilsService.getAvailableUserTabs(this.tabs);
  }

  navigateToTab(tab: Tab) {
    let queryParams = { ...this.tabUtilsService.getAvailableUserTabs(this.tabs)[tab].mainFilterRaw };
    this.mixpanelService.trackEvent("Navigate_To_Tab", { tab: InvestorTab[tab] });
    this.router.navigate([this.tabUtilsService.getAvailableUserTabs(this.tabs)[tab].route], { queryParams });
  }

  updateCurrentTab(tab: Tab){
    this.currentTabIndex = tab;
  }

  initializeDataLoadingStream(url: string) {
    this.url = url;
    if (!this.deviceDetectorService.isMobile()){
      this.modalUtilsService.toggleNavigation.unsubscribe();
      this.modalUtilsService.toggleNavigation = new BehaviorSubject<boolean>(true);
  
      this.globalModalService.close();
    }

    if (url.startsWith("/company/"))
    {
      const companyId = url.split("/company/")[1];
      this.location.replaceState("/companies");
      this.globalModalService.openCompanyModal(companyId);
    }
  }

  private subscribeToTabSwitch() {
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd), // Type narrowing
      )
      .subscribe((event: NavigationEnd) => {
        this.destroy$.next();  // cancel the current HTTP call
        this.initializeDataLoadingStream(event.urlAfterRedirects);
      });
  }

  public updateUrlQueryParams(params: DataFilter, tab: InvestorTab) {
    if (tab != this.currentTabIndex || this.deviceDetectorService.isMobile() || this.globalModalService.displayCompanyDetails){
      return;
    }
    const queryParams = Object.entries(params)
      .filter(([_, value]) => value !== undefined && value !== null && value !== '')
      .map(([key, value]) => {
        if (Array.isArray(value)) {
          return value.map(v => `${encodeURIComponent(key)}=${encodeURIComponent(v)}`).join('&');
        } else {
          return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
        }
      })
      .join('&');
  
    const newUrl = this.router.url.split('?')[0] + (queryParams ? `?${queryParams}` : '');
    this.location.replaceState(newUrl);
  }
}